import React from 'react';
import _t from 'counterpart';
import { Redirect, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import { AppState } from './reducers';
import LoginPage from './pages/LoginPage';
import MainPage, { PUSH_NOTIFICATION_ID } from './pages/MainPage';
import moment from 'moment';

import './scss/style.scss';
import { correctedMomentLocales, supportedLocales } from './locales';
import { useAppDispatch, useAppSelector } from './helpers/customHooks';
import { Toaster } from 'react-hot-toast';
import Notification from './components/Notification';
import FullscreenSpinner from './components/FullscreenSpinner/FullscreenSpinner';
import { toggleDismissPushNotificationsToast } from './actions';

const queryParams = new URLSearchParams(document.location.search.replace(/^\?/, ''));
const queryLang = queryParams.get('lang');
if (queryLang && supportedLocales.includes(queryLang)) {
  localStorage.setItem('locale', queryLang);
}

const language = localStorage.getItem('locale') || 'en';

_t.setLocale(language);

if (Object.keys(correctedMomentLocales).includes(language)) {
  const locale = correctedMomentLocales[language];
  if (locale) {
    moment.locale(locale);
  }
} else {
  moment.locale(localStorage.getItem('locale') || 'en');
}

interface IAppProps {
  communicationLanguage: string;
  globalLoading: boolean;
}

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
const PrivateRoute = ({ children, ...rest }: any) => {
  const { token: isAuthenticated } = useAppSelector((state) => state.user);

  return (
    <Route
      {...rest}
      render={({ location }) =>
        isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: '/login',
              state: { referrer: location.pathname },
            }}
          />
        )
      }
    />
  );
};

const App = ({ communicationLanguage, globalLoading }: IAppProps) => {
  const dispatch = useAppDispatch();

  return (
    <div key={communicationLanguage}>
      <Toaster
        position="top-right"
        toastOptions={{
          className: 'toast',
          duration: 5000,
        }}
      >
        {(t) => (
          <Notification
            t={t}
            onDismissCallback={() => {
              if (t.id === PUSH_NOTIFICATION_ID) {
                dispatch(toggleDismissPushNotificationsToast(true));
              }
            }}
          />
        )}
      </Toaster>
      <Switch>
        <Route exact path="/login">
          <LoginPage />
        </Route>
        <PrivateRoute path="/">
          <MainPage />
        </PrivateRoute>
      </Switch>
      {globalLoading && <FullscreenSpinner />}
    </div>
  );
};

export default connect((state: AppState) => ({
  communicationLanguage: state.core.language,
  globalLoading: state.core.globalLoading,
}))(App);
